import React from 'react';
import {
	buildTestData,
} from 'Vulture/TestData';
import style from './Slideshow.module.css';
import CustomIcon from '../Common/CustomIcon/CustomIcon';

class SlideDeckModal extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			deckName: props?.deckData?.name ?? '',
		};

		this.deckNameInputRef = React.createRef();
	}

	componentDidMount() {
		if (this.deckNameInputRef?.current) {
			this.deckNameInputRef.current.focus();
		}
	}

	render() {
		const {
			app,
			createOrUpdateDeck,
		} = this.props;

		const {
			deckName,
		} = this.state;

		return (
			<>
				<div className={style.slideDeckModal}>
					<div className={style.formGroup}>
						<label>
							Deck Name<br></br>
							<input
								value={deckName}
								id='modalSlideDeckName'
								type='text'
								placeholder='Slide Deck Name'
								ref={this.deckNameInputRef}
								onKeyDown={(e) => {
									if (e.key === 'Enter') {
										e.preventDefault();
										createOrUpdateDeck(deckName);
										app.closeModal();
									}
								}}
								onChange={(e) => {
									this.setState({
										deckName: e.target.value,
									});
								}}
								data-test-id="slideDeckNameInput"
								data-testing-info={buildTestData('input--deck-name')}
							/>
						</label>
					</div>

					<div className={style.bottom}>
						<button
							onClick={(e) => {
								e.preventDefault();
								createOrUpdateDeck(deckName);
								app.closeModal();
							}}
							className="button"
							data-test-id="slideDeckSaveButton"
						>
							<CustomIcon icon='save' /><div>Save</div>
						</button>
					</div>
				</div>
			</>
		);
	}
}

export default SlideDeckModal;
